<template>
    <el-dialog title="设置不开票金额" :visible.sync="dialogVisible" class="mx-50" top="40px">
      <table width=100%>
        <tr>
          <th width=30%>收入总额</th>
          <th width=30% >未确认金额</th>
          <th width=10% ></th>
          <th></th>
        </tr>
        <tr>
          <td>{{receivable_amount}}</td>
          <td>{{modify_unconfirmed_amount}}</td>
          <td></td>
        </tr>
      </table>
      <el-divider></el-divider>
  
      <el-form :rules="rules" ref="dataForm" :model="formData" label-position="left" label-width="150px" class="mx-30">
        <el-form-item prop="no_invoice" label="不开票金额">
          <el-input v-model="formData.no_invoice" autoComplete="on"></el-input>
        </el-form-item>
  
        <el-form-item>
          <span style="float: right">
            <template v-if="showDialogSave">
            <el-button size="small" @click="cancelData">取消</el-button>
            <el-button
                v-if="is_superuser ||(!is_superuser && !formData.is_superuser)"
                type="primary" size="small"
                @click="saveData">保存</el-button>
            </template>
          </span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </template>
  
  <script>
    import { updateFinaceNoInvoice } from '@/api/group-insurance'
  
    export default {
      name: 'receivable-no-invoice-dialog',
      props: [
        'finance_id',
        'receivable_amount',
        'unconfirmed_amount',
        'no_invoice'
      ],
      data() {
        var validateAmount = (rule, value, callback) => {
          if(this.modify_unconfirmed_amount < 0.0) {
            return callback(new Error('未确认金额小于0'))
          } else {
            return callback()
          }
        };
        return {
          dialogVisible: false,
          showDialogSave: true,
          is_superuser: undefined,
          formData: {
            no_invoice: 0,
          },
          initAmount: 0,
          isDisabled: false,
          rules: {
            no_invoice: [
              {required: true, message:'请输入不开票金额' ,trigger: 'blur'},
              {validator: validateAmount, trigger: 'blur'}
            ],
          }
        }
      },
      computed: {
        modify_unconfirmed_amount: function(){
          let result = 0.0
          if (this.formData.no_invoice === null || this.formData.no_invoice === undefined || this.formData.no_invoice === '') {return this.unconfirmed_amount}
          result = this.unconfirmed_amount - parseFloat(this.formData.no_invoice) + this.initAmount
          return result.toFixed(4)
        },
      },
      methods: {
        resetFormData() {
          this.formData = {
            no_invoice: 0,
          }
          this.isDisabled = false
        },
        handleUpdate(showDialogSave) {
          this.showDialogSave = showDialogSave
          let login_userid = this.$store.state.user.user
          this.resetFormData()
          this.formData.no_invoice = this.no_invoice
          this.initAmount = this.no_invoice
          this.dialogVisible = true
          this.isDisabled = true
        },
        cancelData() {
          this.resetFormData()
          this.$nextTick(() => {
            this.$refs.dataForm.clearValidate()
          })
          this.dialogVisible = false
        },
        saveData(){
          this.$refs['dataForm'].validate(valid => {
            if (valid) {
              updateFinaceNoInvoice(this.finance_id, this.formData).then(res => {
                this.$message.success('设置不开票金额成功')
                this.$refs.dataForm.resetFields()
                this.dialogVisible = false
                this.$emit('updateNoInvoice', res.no_invoice)
              }).catch(error => {
                this.$error_message(error)
              })
            }
          })
        }
      },
      created() {
      }
    }
  </script>
  